<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 19:29:09
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 14:45:51
-->
<template>
	<span>
		<el-dialog title="团长授权" width="600px" show-close :visible.sync="visible" :before-close="handleClose">
			<el-alert
				title="由于抖音官方调整，您需重新授权团长账号，授权后可正常使用系统！！"
				type="info"
				show-icon
				:closable="false"
				class="mb-16 mt-8"
				v-if="!authFailed"
			></el-alert>
			<el-alert title="团长账号授权失败，请重新前往授权" type="error" show-icon :closable="false" class="mb-32" v-if="authFailed"></el-alert>
			<i class="el-icon-caret-right"></i>
			<div class="flex-row flex-align-between flex-just-start">
				<div v-for="step in stepList" :key="step.id" class="text-center flex-1 flex-column flex-align-center">
					<img :src="step.icon" alt="" width="80px" class="mb-22" />
					<p>第{{ step.stepTxt }}步:</p>
					<p style="width: 220px" class="align-center">{{ step.desc }}</p>
					<el-button type="text" @click="step.click">
						{{ step.btnText }}
						<i class="el-icon-arrow-right"></i>
					</el-button>
				</div>
			</div>
			<!-- 福利提示 -->
			<div class="weal_tips flex-align-center flex mt-16">
				<img src="@/assets/public/weal.png" alt="" class="weal mr-8 ml-12" />
				<span class="fz-12 PingFang">福利：授权后在【精选联盟服务市场】进行五星好评，凭截图可延长7天系统使用时长</span>
				<span style="color: #2475ff" class="fz-12 ml-8 pointer" @click="gotoWeal">查看 ></span>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button
					type="text"
					class="footer-left-btn fz-14"
					@click="handLink('https://chaoyongtuan.yuque.com/docs/share/b8a51b26-002c-4fb0-be98-865a249e6d13')"
				>
					完整授权教程
				</el-button>
				<el-button @click="handleClose">关闭</el-button>
				<el-button type="primary" @click="checkAuth">已完成授权</el-button>
			</div>
		</el-dialog>

		<DyAuthSuccess ref="authSuccess"></DyAuthSuccess>
	</span>
</template>
<script>
import mixin from './mixin';
import DyAuthSuccess from './dyAuthSuccess.vue';
import { checkState } from '@/api/teamManage';
export default {
	name: 'auth-alert',
	mixins: [mixin],
	props: {
		type: {
			type: String,
			default: 'goods',
			validator: val => !['goods', 'activity'].includes[val],
		},
	},
	computed: {
		authFailed() {
			return this.bindStatus === 'fail';
		},
	},
	data() {
		return {
			visible: false,
			link: '',
			bindStatus: '',
			call_id: 0,
			platformId: '',
			stepList: [
				{
					id: 1,
					stepTxt: '一',
					desc: '请前往精选联盟服务市场订阅 “超佣团”，点击 “去使用” 返回超佣团',
					icon: require('@/assets/public/auth_step_1.png'),
					btnText: '前往订阅',
					click: () => this.handLink('https://market.jinritemai.com/detail?service_id=23955'),
				},
				{
					id: 2,
					stepTxt: '二',
					desc: '授权 “超佣团” 团长信息',
					icon: require('@/assets/public/auth_step_2.png'),
					btnText: '前往授权',
				},
			],
		};
	},
	methods: {
		init(link, platformId, call_id) {
			this.link = link;
			this.platformId = platformId;
			this.call_id = call_id;
			this.visible = true;
			this.stepList.find(item => item.id === 2).click = () => this.handLink(link);
		},
		async checkAuth() {
			let params = {
				platformId: this.platformId,
				callId: this.call_id,
			};
			const { data } = await checkState(params);
			this.bindStatus = data.auth_status ? 'success' : 'fail';
			if (!data.auth_status) {
				this.$message.error('团长账号授权失败，请重新前往授权');
			} else {
				this.handleSuccess();
			}
		},
		// 打开福利
		gotoWeal() {
			window.open('https://chaoyongtuan.yuque.com/docs/share/4a010eef-8565-4103-8b7b-781cfe036747?#', '_blank');
		},
		// 前往订阅或者授权
		handLink(link) {
			window.open(link, '_blank');
		},
		handleClose() {
			this.bindStatus = '';
			this.visible = false;
		},
		handleSuccess() {
			this.bindStatus = 'success';
			this.$emit('success');
			this.$refs.authSuccess.show();
			this.handleClose();
		},
	},
	components: {
		DyAuthSuccess,
	},
};
</script>
<style lang="less" scoped>
.dialog-footer {
	position: relative;
}
.footer-left-btn {
	position: absolute;
	left: 0;
}
.weal_tips {
	color: #4e596a;
	> .weal {
		width: 24px;
		height: 24px;
	}
}
.el-icon-caret-right {
	position: relative;
	top: 56px;
	left: 280px;
	font-size: 16px;
}
/deep/.el-alert--info.is-light {
	background-color: #fef0f0;
	color: #ff7038;
}
</style>
